import { Sort } from "../../../models/api/sort";

export interface SortByQuickFilter {
  sortByOptions: SortByOptionValue;
}

export interface SortByOptionValue {
  sortBy: Sort[];
}

export interface Props<Q extends SortByQuickFilter> {
  quickFilters: Q;
  handleChangeQuickFilters: (filter: keyof Q, value: SortByOptionValue) => void;
  isExpenseReportOrReceipt?: "report" | "receipt";
}

export const SORT_BY_QF_NAMES = {
  date: "date",
  amount: "amount",
  country: "country",
  description: "description",
  type: "type",
  auditAccepted: "auditAccepted",
  modifiedAt: "modifiedAt",
};
